// extracted by mini-css-extract-plugin
export default {"chatWrapper":"ChatButton_chatWrapper__+ydPv","chatButton":"ChatButton_chatButton__4HfVQ","chatLabel":"ChatButton_chatLabel__z0yTJ"};